import styled from 'styled-components';

export const StyledBasicInfo = styled.div`
  padding: 24px 28px 0;

  .bi-wrapper {
    width: 100%;
    max-height: 60vh;
    overflow-y: auto;

    &-box {
      display: flex;
      gap: 32px;

      & > div {
        flex: 1;
      }
    }

    &-bottom {
      margin-top: 16px;

      .row.date {
        width: 310px;
      }
    }
  }

  .bi-footer {
    display: flex;
    justify-content: flex-end;
    padding: 28px 0;
    gap: 12px;

    > button {
      width: auto;
    }
  }
`;

export const StyledBasicInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .basicImagebox {
    margin-bottom: 0;
  }
`;

export const StyledBasicInfoName = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  > div {
    margin-bottom: 0;

    &:first-of-type {
      width: 100%;
    }

    &.no-label {
      width: 100%;

      > span {
        color: transparent;
        user-select: none;

        > span {
          color: transparent;
          user-select: none;
        }
      }
    }
  }
`;

export const StyledBasicInfoMobile = styled.div`
  display: flex;
  align-items: end;
  gap: 8px;

  > div {
    margin-bottom: 0;

    &:first-of-type {
      width: 100%;
    }

    &.no-label {
      width: 100%;

      > span {
        color: transparent;
        user-select: none;

        > span {
          color: transparent;
          user-select: none;
        }
      }
    }
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const StyledBasicInfoBottom = styled.div``;
